<template>
  <div>
    <h3 class="text-center subtitle2 text-22 lg:text-28 lg:text-left">
      {{ heading }}
    </h3>

    <table class="mt-6 lg:mt-8 w-full table-fixed">
      <tbody>
        <tr
          v-for="(amounts, i) in rates"
          :key="i"
          class="group font-semibold text-18 whitespace-nowrap"
        >
          <td
            class="py-3 px-6 lg:py-5 border-2 bg-gray-50 group-hover:bg-gray-100 group-hover:border-gray-300"
          >
            {{ getAmount(amounts[0]) }} {{ currencyFrom }}
          </td>
          <td
            class="py-3 px-6 lg:py-5 border-2 bg-white group-hover:bg-gray-50 group-hover:border-gray-300 text-right"
          >
            {{ getAmount(amounts[1]) }} {{ currencyTo }}
          </td>
        </tr>
      </tbody>
    </table>

    <div
      class="text-right text-12 text-gray-500 inline-block w-full py-2"
      :class="{ 'chromatic-ignore': isChromatic }"
    >
      {{ $t('source') }} <XeLink /> | {{ $t('last_updated', { ago: '' }) }}
      <NuxtTime :datetime="updatedAgo" :locale="$lang" relative />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  heading: string
  rates: number[][]
  currencyFrom: string
  currencyTo: string
  updatedAgo: number
}>()

const { $lang } = useNuxtApp()

function getAmount(amount: number) {
  return formatNumber(amount, $lang, {
    minimumFractionDigits: 0,
    maximumFractionDigits: amount > 1000 ? 0 : 6,
  })
}
</script>
